import { render, staticRenderFns } from "./GuideList.vue?vue&type=template&id=2470fb2c&scoped=true"
import script from "./GuideList.vue?vue&type=script&lang=js"
export * from "./GuideList.vue?vue&type=script&lang=js"
import style0 from "./GuideList.vue?vue&type=style&index=0&id=2470fb2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470fb2c",
  null
  
)

export default component.exports